module.exports = __webpack_public_path__ + "img/credit-card-brands.db93963f.png";